import React from 'react';
import { Select, Input, Button, Icon, Tooltip, Popconfirm, Checkbox, DatePicker, Popover, Switch, message } from 'antd';
import SERVER_URL from '../Global';
import moment from 'moment';
import { Link } from 'react-router-dom';

const { Option } = Select;

class EditHr extends React.Component {
    constructor(props) {
        super(props);
        let contatti = []
        let hrName = null
        let title = null
        let hrSurname = null
        let startDate = null
        let endDate = null
        let hrid = ''
        let adInterim = null
        let hrCreated = true
        let disabledHrDetails = false
        let addresses = []
        let showAddress = false
        let collabId = ''
        let beShowAddress = false
        let collabCompanies = []

        if (this.props.data != null) {              
            adInterim = this.props.data.isAdInterim
            if (this.props.data.workingFor != null) {
                this.props.data.workingFor.office.addresses.map(add => {
                    addresses.push(add)
                })
                collabId = this.props.data.workingForHROId
                if (this.props.data.workingFor.office != null) {
                    collabCompanies.push({ compId: this.props.data.workingFor.office.company.companyId, compName: this.props.data.workingFor.office.company.name })
                }
            }

            if (this.props.data.showAddressWorkingFor) {
                beShowAddress = true
                showAddress = true
            }

            this.props.data.brHrRoleOfficeContacts.sort(({ sort: previousID }, { sort: currentID }) => previousID - currentID).map((con, i) => {                
                contatti.push({ text: con.contact.text, id: i, remove: false, contactId: con.contact.contactId, propId: con.contact.property_TrValue, contactCreated: true, isCollaboration: con.isCollaboration })
            })

            if (this.props.data.hr != null) {
                hrName = this.props.data.hr.name
                title = this.props.data.title
                hrSurname = this.props.data.hr.surname
                hrid = this.props.data.hrId
                
                if (this.props.data.startDate != null) {
                    console.log(this.props.data.startDate);

                    startDate = moment(this.props.data.startDate, "YYYY-MM-DD");
                } else {
                    startDate = null
                }
                if (this.props.data.endDate != null) {
                    endDate = moment(this.props.data.endDate, "YYYY-MM-DD");
                } else {
                    endDate = null
                }

            } else {
                hrCreated = false
                hrid = ''
                startDate = null
                endDate = null
                if (this.props.data.brHrRoleOfficeContacts.length > 0) {
                    disabledHrDetails = true
                }
            }
        }

        this.state = {
            user: this.props.user,
            hrCreated: hrCreated,
            roleStatus: this.props.roleStatus,
            position: this.props.i + 1,
            hrName: hrName,
            title: title,
            hrSurname: hrSurname,
            roleId: this.props.roleId,
            contactsHr: ['0'],
            properties: this.props.properties,
            officeId: this.props.officeId,
            hroidCreated: true,
            contactHrId: 0,
            startValue: startDate,
            endValue: endDate,
            endOpen: false,
            isHr: this.props.isHr,
            companies: [],
            collabId: collabId,
            basicHroid: this.props.basicHroid,
            shrinked: false,
            propId: 3,
            contactModified: false,
            hrNameValidation: true,
            hrContactText: '',
            hrId: hrid,
            emailContactAlert: false,
            contacts: contatti,
            hroId: this.props.data.hroId,
            hrDeleted: false,
            adInterim: adInterim,
            isAllUpdated: true,
            uniqueId: this.props.handleId,
            expanded: false,
            mandatoryName: true,
            mandatorySurname: true,
            disabledHrDetails: disabledHrDetails,
            addresses: addresses,
            showAddress: showAddress,
            beShowAddress: beShowAddress,
            noDetailsHrCounter: this.props.noDetailsHrCounter,
            hrOrder: this.props.order,
            saveButtonDisabled: false,
            contactValidator: true,
            endDateMessage: false,
            collabCompanies: collabCompanies,
            collabCompaniesWithThis: [],
        };

        this.handleNameChange = this.handleNameChange.bind(this);
        this.handleTitleChange = this.handleTitleChange.bind(this);
        this.saveCombo = this.saveCombo.bind(this);
        this.handleSurnameChange = this.handleSurnameChange.bind(this);
        this.saveHr = this.saveHr.bind(this);
        this.handleContactText = this.handleContactText.bind(this);
        this.handleProp = this.handleProp.bind(this);
        this.orderUp = this.orderUp.bind(this);
        this.orderDown = this.orderDown.bind(this);
        this.expand = this.expand.bind(this);
        this.shrink = this.shrink.bind(this);
        this.addInput = this.addInput.bind(this);
        this.removeContact = this.removeContact.bind(this);
        this.deleteHr = this.deleteHr.bind(this);
        this.handleInterim = this.handleInterim.bind(this);
        this.saveContacts = this.saveContacts.bind(this);
        this.onChangeSwitchHrDetails = this.onChangeSwitchHrDetails.bind(this);
        this.closeWarning = this.closeWarning.bind(this);

        if (this.state.properties.length < 1) {
            //proprietà
            fetch(
                `${SERVER_URL + 'api/translation/list'}`, {
                    method: 'POST',
                    headers: {
                        'Authorization': `Bearer ${this.state.user}`,
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        "typeTip": "Property",
                        "page": 1,
                        "totalPages": 0,
                        "totalItems": 0,
                        "pageSize": 40,
                        "pageSizeOptions": null,
                        "ordering": {
                            "orderPropertyName": 'name',
                            "order": 1
                        },
                        "firstItemNumber": 0,
                        "lastItemNumber": 0,
                        "entityId": 0
                    })
                }
            ).then(response => response.json())
            .then(res => {
                this.setState({ properties: res.data }, this.setState({ propLoad: false }));
            })
        }
    }

    handleNameChange(event) {
        this.setState({ hrName: event.target.value, isAllUpdated: false, mandatoryName: true });
        if (event.target.value.length === 0) {
            this.setState({ hrName: null, mandatoryName: false })
        }
    }

    handleSurnameChange(event) {
        this.setState({ hrSurname: event.target.value, isAllUpdated: false, mandatorySurname: true });

        if (event.target.value.length === 0) {
            this.setState({ hrSurname: null, mandatorySurname: false })
        }
    }

    handleTitleChange(event) {
        this.setState({ title: event.target.value, isAllUpdated: false });
        if (event.target.value.length === 0) {
            this.setState({ title: null })
        }
    }

    disabledStartDate = startValue => {
        const { endValue } = this.state;
        if (!startValue || !endValue) {
            return false;
        }
        return startValue.valueOf() > endValue.valueOf();
    };

    disabledEndDate = endValue => {
        const { startValue } = this.state;
        if (!endValue || !startValue) {
            return false;
        }
        return endValue.valueOf() <= startValue.valueOf();
    };

    onChange = (field, value) => {
        this.setState({
            [field]: value,
            isAllUpdated: false
        });
    };

    onStartChange = value => {
        value = moment(value).add(2, 'hours');
        this.setState({ startValue: value, isAllUpdated: false });
    };

    onEndChange = value => {
        value = moment(value).add(2, 'hours');
        this.setState({ endValue: value, isAllUpdated: false });
        fetch(
            `${SERVER_URL + 'api/brHrRoleOffice/companyCollaborations/' + this.state.hroId}`, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${this.state.user}`,
                    'Content-Type': 'application/json'
                }
            }
            ).then(response => response.json())
                .then(res => {
                    if (res.data != null) {
                        this.setState({ collabCompaniesWithThis: res.data })
                    }
                }
                ) 
        let tOrF = false
        if (value != null) {
            tOrF = true
        } else {
            tOrF = false
        }        
        this.setState({ endDateMessage: tOrF })
    };

    handleStartOpenChange = open => {
        if (!open) {
            this.setState({ endOpen: true });
        }
    };

    handleEndOpenChange = open => {
        this.setState({ endOpen: open });
    };


    saveHr() {
        this.setState({ saveButtonDisabled: true })
        if (!this.state.disabledHrDetails) {
            if (this.state.hrCreated === false && this.state.roleStatus === true && this.state.hrName != null) {
                this.setState({ loading: true })
                fetch(
                    `${SERVER_URL + "api/hr"}`, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${this.state.user}`
                        },
                        body: JSON.stringify({
                            'name': this.state.hrName,
                            'surname': this.state.hrSurname,
                            "Status": this.props.status
                        })
                    }
                ).then(response => response.json())
                    .then(res => {
                        this.setState({ saveButtonDisabled: false, expanded: false, hrCreated: true, loading: false, hrDeleted: false, hrId: res.data, contactModified: false, isAllUpdated: true, hrNumber: this.state.hrNumber + 1 }, this.saveCombo(res.data, this.state.roleId));
                        this.sendStateHrCreated()
                    })
            } else if (this.state.hrCreated === false && this.state.roleStatus === false) {
                //stai creando un hr senza aver inserito un ruolo
            } else if (this.state.hrCreated === true && this.state.roleStatus === true) {
                fetch(`${SERVER_URL + 'api/hr'}`, {
                    method: 'PUT',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${this.state.user}`
                    },
                    body: JSON.stringify({
                        'name': this.state.hrName,
                        'surname': this.state.hrSurname,
                        'hrid': `${this.state.hrId}`,
                        "Status": this.props.status
                    })
                }).then(
                    this.saveContacts
                )
                this.setState({ saveButtonDisabled: false, expanded: false, contactModified: false, isAllUpdated: true }, this.saveCombo(this.state.hrId, this.state.roleId))
            } else if (this.state.hroidCreated === true && this.state.roleStatus === true && this.state.hrName == null) {
                //stai creando un hr senza aver inserito un nome
                this.setState({ saveButtonDisabled: false, expanded: false, contactModified: false, isAllUpdated: true }, this.saveContacts)
                this.saveCombo(this.state.hrId, this.state.roleId)
            }
        } else {
            //salva hr senza dettagli
            this.setState({ saveButtonDisabled: false, expanded: false, contactModified: false, isAllUpdated: true }, this.saveContacts)
            this.saveCombo(null, this.state.roleId)
        }
    }

    deleteHr() {
        fetch(
            `${SERVER_URL + 'api/brhrroleoffice/hard/' + this.state.hroId}`, {
                method: 'DELETE',
                headers: {
                    'Authorization': `Bearer ${this.state.user}`,
                    'Content-Type': 'application/json'
                }
            }
        ).then(response => response.json())
            .then(res => {
            })
        this.setState({ hrCreated: false, hrDeleted: true })
        this.sendDataToHandleRole(this.props.i)
        this.sendCounterToHandleRole()
    }


    saveCombo(HrId, roleId) {
        if (this.state.hroidCreated === false) {
            this.setState({ loading: true });
            fetch(
                `${SERVER_URL + "api/brHrRoleOffice"}`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${this.state.user}`
                    },
                    body: JSON.stringify({
                        "officeId": this.state.officeId,
                        "roleId": roleId,
                        "hrId": HrId,
                        "WorkingForHROId": this.props.collabId,
                        "Status": this.props.status,
                        "StartDate": this.state.startValue,
                        "EndDate": this.state.endValue,
                        "isAdInterim": this.state.adInterim,
                        "Sort": this.state.hrOrder,
                        'title': this.state.title,
                        "ShowAddressWorkingFor": this.state.showAddress
                    })
                }
            ).then(response => response.json())
                .then(res => {
                    this.setState({ hroId: res.data, hroidCreated: true, loading: false }, this.saveContacts);
                }
                )
        } else {
            fetch(
                `${SERVER_URL + "api/brHrRoleOffice"}`, {
                    method: 'PUT',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${this.state.user}`
                    },
                    body: JSON.stringify({
                        "officeId": this.state.officeId,
                        "roleId": roleId,
                        "hrId": HrId,
                        "hroId": this.state.hroId,
                        "WorkingForHROId": this.props.collabId,
                        "Status": this.props.status,
                        "StartDate": this.state.startValue,
                        "EndDate": this.state.endValue,
                        "isAdInterim": this.state.adInterim,
                        "Sort": this.state.hrOrder,
                        'title': this.state.title,
                        "ShowAddressWorkingFor": this.state.showAddress
                    })
                }
            )
        }
    }

    saveContacts() {
        //salva contatti
        this.state.contacts.map((con, i) => {
            if (!con.remove && !con.contactCreated) {
                fetch(
                    `${SERVER_URL + "api/contact"}`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${this.state.user}`
                    },
                    body: JSON.stringify({
                        'text': `${con.text}`,
                        'HROId': `${this.state.hroId}`,
                        'Property_TrValue': `${con.propId}`
                    })
                }
                ).then(response => response.json())
                    .then(res => {
                        this.state.contacts[i].contactId = res.data
                        this.state.contacts[i].contactCreated = true

                        //colleghiamo il contatto alla role office
                        fetch(
                            `${SERVER_URL + "api/brHrRoleOfficeContact"}`, {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json',
                                'Authorization': `Bearer ${this.state.user}`
                            },
                            body: JSON.stringify({
                                'hroId': this.state.hroId,
                                'contactId': res.data,
                                'isCollaboration': con.isCollaboration,
                                "Status": 1,
                                'sort': i
                            })
                        })
                        // fine fetch
                    }
                    )
            } else if (!con.remove && con.contactId !== '') {
                fetch(`${SERVER_URL + 'api/contact'}`, {
                    method: 'PUT',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${this.state.user}`
                    },
                    body: JSON.stringify({
                        'text': `${con.text}`,
                        'Property_TrValue': `${con.propId}`,
                        'HROId': `${this.state.hroId}`,
                        'contactid': con.contactId,
                        'sort': i
                    })
                }).then(response => response.json())
                    .then(res => {
                        fetch(
                            `${SERVER_URL + "api/brHrRoleOfficeContact/"}`, {
                            method: 'PUT',
                            headers: {
                                'Content-Type': 'application/json',
                                'Authorization': `Bearer ${this.state.user}`
                            },
                            body: JSON.stringify({
                                'hroId': this.state.hroId,
                                'contactId': res.data,
                                'isCollaboration': false,
                                "Status": 1,
                                'sort': con.id
                            })
                        })
                    })
            }
            else if (con.remove && con.contactCreated) {
                //scolleghiamo il contatto dalla role office
                fetch(
                    `${SERVER_URL + "api/brHrRoleOfficeContact/" + this.state.hroId + "/" + con.contactId}`, {
                    method: 'DELETE',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${this.state.user}`
                    }
                }).then(response => response.json())
                    .then(res => {
                        this.state.contacts[i].contactCreated = false

                        if (!con.isCollaboration) {
                            fetch(`${SERVER_URL + `api/contact/hard/${con.contactId}`}`, {
                                method: 'DELETE',
                                headers: {
                                    'Content-Type': 'application/json',
                                    'Authorization': `Bearer ${this.state.user}`
                                }
                            }).then(response => response.json())
                            .then(res => {
                                if (!res.ok) {
                                    message.warning("The contact is shared by other companies, it has not been deleted")
                                }
                            })
                        }
                    })
                //fine fetch
            }
        })
    }

    //inizio contatti
    handleProp(value, i) {
        let emailValidator = true
        let urlValidator = true
        if (!this.state.contacts.hasOwnProperty(i)) {
            this.state.contacts.push({ text: '', id: i, remove: false, contactId: '', propId: value })
        } else {
            this.state.contacts[i].propId = value
            if ((value == 5 || value == 23) && !this.state.contacts[i].text.includes('@')) {
                document.getElementById("emailHasAtHr" + i + this.state.roleId + this.state.uniqueId).style.display = 'block'
                emailValidator = false
            }
            else {
                document.getElementById("emailHasAtHr" + i + this.state.roleId + this.state.uniqueId).style.display = 'none'
                emailValidator = true
            }
            if (value == 4 && !this.state.contacts[i].text.includes('http')) {
                document.getElementById("urlHasHttp" + i + this.state.roleId + this.state.uniqueId).style.display = 'block'
                urlValidator = false
            } else {
                document.getElementById("urlHasHttp" + i + this.state.roleId + this.state.uniqueId).style.display = 'none'
                urlValidator = true
            }
        }
        let contactValidator = emailValidator && urlValidator ? true : false
        this.setState({ contactModified: true, contactValidator: contactValidator });
    }

    handleContactText(event, i) {
        var field = "contactText" + i
        if (event.target.value.length > 0) {
            this.setState({ [field]: event.target.value, contactModified: true });
        } else if (event.target.value.length === 0) {
            this.setState({ contactModified: false });
        }
    }

    addContact(i) {
        let emailValidator = true
        let urlValidator = true
        var field = "contactText" + i
        var text = this.state[field]

        if (!this.state.contacts.hasOwnProperty(i)) {
            this.state.contacts.push({ text: text, id: i, remove: false, contactId: '', propId: 3, contactCreated: false })
        } else {
            if (text === undefined) {
                this.setState({
                    [field]: this.state.contacts[i].text
                })
            }
            else {
                this.state.contacts[i].text = text
                if ((this.state.contacts[i].propId === 5 && this.state.contacts[i].propId === 23) && !text.includes('@')) {
                    document.getElementById("emailHasAtHr" + i + this.state.roleId + this.state.uniqueId).style.display = 'block'
                    emailValidator = false
                }
                else {
                    document.getElementById("emailHasAtHr" + i + this.state.roleId + this.state.uniqueId).style.display = 'none'
                    emailValidator = true
                }
                if (this.state.contacts[i].propId === 4 && !text.includes('http')) {
                    document.getElementById("urlHasHttp" + i + this.state.roleId + this.state.uniqueId).style.display = 'block'
                    urlValidator = false
                }
                else {
                    document.getElementById("urlHasHttp" + i + this.state.roleId + this.state.uniqueId).style.display = 'none'
                    urlValidator = true
                }
            }
        }
        let contactValidator = emailValidator && urlValidator ? true : false
        this.setState({ contactModified: true, contactValidator: contactValidator, saveButtonDisabled: false });
    }

    addInput(i) {
        if (i >= this.state.contactHrId) {
            var id = this.state.contactHrId + 1

            this.setState({ contactHrId: id })

            this.state.contactsHr.push(id)

            this.state.contacts.push({ text: '', id: id, remove: false, contactId: '', propId: 3, contactCreated: false, isCollaboration: false })
        }
    }

    removeContact(i) {
        if (this.state.contacts.hasOwnProperty(i)) {
            this.state.contacts[i].remove = true
        }

        this.setState({ contactModified: true })

        document.getElementById("contactHr_" + this.state.roleId + "_" + this.state.hrId + "_" + i).remove()
    }

    //fine contatti

    handleInterim(e) {
        let interim = false
        if (e.target.checked) {
            interim = true
        } else {
            interim = false
        }
        this.setState({ isAllUpdated: false, adInterim: interim })
    }

    shrink() {
        this.setState({ shrinked: true })
    }

    expand() {
        this.setState({ shrinked: false })
    }

    orderUp() {
        this.setState({ position: this.state.position - 1 })
    }

    orderDown() {
        if (this.state.position > 0) {
            this.setState({ position: this.state.position + 1 })
        }
        else {
            //stai spostando l'hr troppo in alto
        }
    }

    componentDidUpdate(prevProps) {
        // Typical usage (don't forget to compare props):
        if (this.props.order !== prevProps.order && this.state.hroidCreated) {
            this.newOrder(this.props.order);
            this.setState({ hrOrder: this.props.order })
        }
        if (this.props.noDetailsHrCounter !== prevProps.noDetailsHrCounter) {
            this.setState({ noDetailsHrCounter: this.props.noDetailsHrCounter })
        }
    }

    componentDidMount() {
        //invio al componente padre l'avviso che c'è un componente figlio con disabledHrDetails  

        this.sendnoDetailsHrCounter()
    }

    sendnoDetailsHrCounter = () => {
        if (this.state.disabledHrDetails == true) {
            this.props.parentnoDetailsCounter(1);
        }
    }

    sendOrder = () => {
        let order = this.state.hrOrder - 1
        this.props.parentCallbackOrder(order);
    }

    newOrder(order) {
        fetch(
            `${SERVER_URL + "api/brHrRoleOffice"}`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${this.state.user}`
                },
                body: JSON.stringify({
                    "hroid": this.state.hroId,
                    "officeId": this.state.officeId,
                    "roleId": this.state.roleId,
                    "hrId": this.state.hrId,
                    "WorkingForHROId": this.props.collabId,
                    "Status": this.props.status,
                    "StartDate": this.state.startValue,
                    "EndDate": this.state.endValue,
                    "Sort": order,
                    "title": this.state.title,
                    "ShowAddressWorkingFor": this.state.showAddress
                })
            }
        ).then(response => response.json())
            .then(res => {
            })
    }

    sendDataToHandleRole = () => {
        this.props.showOrderButtons(false, this.props.i);
    }

    sendCounterToHandleRole = () => {
        this.props.parentCounterDeletedHr(1);
    }

    sendStateHrCreated = () => {
        this.props.callbackHrIsCreated(this.state.hrCreated);
    }

    onChangeSwitchHrDetails(value) {
        let valueOpposite = value ? false : true
        this.setState({ disabledHrDetails: valueOpposite, isAllUpdated: false })

        this.sendnoDetailsHrCounter()
    }

    closeWarning() {
        this.setState({ endDateMessage: false })
    }

    render() {

        var selectBeforeProp = (i) => {
            let value = ''
            try {
                var propInd = this.state.properties.findIndex(obj => obj.value == this.state.contacts[i].propId)

                value = this.state.properties[propInd].text
            } catch (e) {
                message.error("Error loading contacts: " + e.message, 5);
            }

            return (
                <Select onChange={(value) => this.handleProp(value, i)} defaultValue={value} style={{ width: 90 }}>
                    {this.state.properties.map(prop => {
                        if (prop.value != 6) {
                            return <Option key={prop.text} value={prop.value}>{prop.text}</Option>
                        }
                    })
                    }
                </Select>
            )
        };

        let checkGreen = this.state.isAllUpdated && !this.state.contactModified && !this.state.expanded ? true : false

        let allSavedBlock = <p>Everything is already Saved</p>

        let mandatoryNotMet = this.state.contactValidator ? <p> One or more Mandatory Fields are empty</p> : <p> One or more contact are not validated</p>

        let mandatoryName = this.state.mandatoryName ? <Icon type="check-circle" /> : <Tooltip title="This field is mandatory"><Icon type="exclamation-circle" /></Tooltip>

        let mandatorySurname = this.state.mandatorySurname ? <Icon type="check-circle" /> : <Tooltip title="This field is mandatory"><Icon type="exclamation-circle" /></Tooltip>

        let { startValue, endValue, endOpen } = this.state;

        let name = this.props.data.hr !== null ? this.props.data.hr.name : ''

        let title = this.props.data.hr !== null ? this.state.title : ''

        let surname = this.props.data.hr !== null ? this.props.data.hr.surname : ''

        let nameSurname = !this.state.disabledHrDetails ?
            <div style={{ display: 'flex' }} className="nameSurnameBox">
                <Input autoComplete="new-password" defaultValue={name} className={"hrName contactText hrNameValidation" + this.state.hrNameValidation} allowClear={true} placeholder="Name" onChange={this.handleNameChange} />
                {mandatoryName}
                <Input autoComplete="new-password" defaultValue={surname} className="hrSurname contactText" allowClear={true} placeholder="Surname" onChange={this.handleSurnameChange} />
                {mandatorySurname}
            </div> : null

        let inputTitle = !this.state.disabledHrDetails ? <Input autoComplete="new-password" defaultValue={title} className="hrTitle" placeholder="Title" allowClear={true} onChange={this.handleTitleChange} /> : null
        let checkDisabled = <p>It is not possible to activate this switch if there are more than one HR for the role</p>
        let inputCheckBox = !this.state.disabledHrDetails ? <Checkbox checked={this.state.adInterim} style={{ marginLeft: '15px' }} onChange={(e) => this.handleInterim(e)}>Ad Interim</Checkbox> : null
        let switchNoDetails = this.state.noDetailsHrCounter == 0 ? this.state.hrName && this.state.hrSurname ? <Switch disabled style={{ marginTop: '22px', marginLeft: '15px' }} defaultChecked={true} onChange={this.onChangeSwitchHrDetails} /> : <Switch style={{ marginTop: '22px', marginLeft: '15px' }} defaultChecked={true} onChange={this.onChangeSwitchHrDetails} /> : this.state.disabledHrDetails ? <Switch style={{ marginTop: '22px', marginLeft: '15px' }} disabled checked={false} onChange={this.onChangeSwitchHrDetails} /> : <Popover content={checkDisabled}><Switch disabled checked={true} style={{ marginTop: '22px', marginLeft: '15px' }} onChange={this.onChangeSwitchHrDetails} /></Popover>
        let hrSave = checkGreen ?
            <Popover content={allSavedBlock}>
                <Button disabled className="saveButtonHrWizard" icon="save">Save Hr</Button>
            </Popover>
            : this.state.mandatoryName && this.state.mandatorySurname && this.state.contactValidator ?
                <Button onClick={this.saveHr} disabled={this.state.saveButtonDisabled} className="saveButtonHrWizard" icon="save">Save Hr</Button>
                : <Popover content={mandatoryNotMet}>
                    <Button disabled className="saveButtonHrWizard" icon="save">Save Hr</Button>
                </Popover>

        let nameSurnameDetail =
            <div className="hrItemLeft" >
                <div style={{ width: '100%', display: 'inline-flex' }}>
                    <Tooltip placement="topLeft" title="Switch to create Role without Hr">
                        <h4 style={{ width: 'auto' }}><Icon type="info-circle" /> Hr Details:</h4>
                    </Tooltip>
                    {switchNoDetails}
                </div>
                {inputTitle}
                {inputCheckBox}
                {nameSurname}
            </div>

        let listOfCollab = this.state.collabCompanies.length > 0 ?
            this.state.collabCompanies.map(el => {
                return <li key={el.compId}><Link to={"/edit?id=" + el.compId} target="_blank">{el.compName}</Link></li>
            }) : null

        let listOfCollabWith = this.state.collabCompaniesWithThis.length > 0 ? 
            this.state.collabCompaniesWithThis.map(el => {
                return <li key={el.companyId}><Link to={"/edit?id=" + el.companyId} target="_blank">{el.name}</Link></li>
            }) : null

        let endDateText = this.state.collabCompanies.length > 0 ? 
            <p className="warningMessage">Warning, this is a collaboration of:</p> :
            this.state.collabCompaniesWithThis.length > 0 ?
                <p className="warningMessage">Warning, the Hr in this Role is also present in the following Companies as Collaboration:</p> :
                null

        let endDateMessage = this.state.endDateMessage == true && (this.state.collabCompanies.length > 0 || this.state.collabCompaniesWithThis.length > 0) ?
            <div style={{border:'1px solid red', padding: '25px'}}>
                {endDateText}
                <ul>{listOfCollab}{listOfCollabWith}</ul>
                <Button onClick={this.closeWarning} className="closeWarning" icon="close">Close Warning</Button>
            </div> 
            : null

        let datePicker = !this.state.disabledHrDetails ?
            <div>
                <div style={{ display: 'inline-flex', width: 'calc(100% - 1px)', marginBottom: '1em' }}>

                    <div className="hrItemLeftSecondRow" >
                        <Tooltip placement="topLeft" title="Select here the starting date">
                            <h4><Icon type="info-circle" /> Starting Date:</h4>
                        </Tooltip>
                        <DatePicker
                            disabled={this.state.disabledHrDetails}
                            disabledDate={this.disabledStartDate}
                            format="DD/MM/YYYY"
                            value={this.state.startValue}
                            className="startDatePicker"
                            placeholder="DD/MM/YYYY"
                            onChange={this.onStartChange}
                            onOpenChange={this.handleStartOpenChange}
                        />
                    </div>

                    <div className="hrItemRightSecondRow" >
                        <Tooltip placement="topLeft" title="Select here the ending date">
                            <h4><Icon type="info-circle" /> Ending Date:</h4>
                        </Tooltip>

                        <DatePicker
                            disabled={this.state.disabledHrDetails}
                            disabledDate={this.disabledEndDate}
                            format="DD/MM/YYYY"
                            defaultValue={endValue}
                            className="endDatePicker"
                            placeholder="DD/MM/YYYY"
                            onChange={this.onEndChange}
                            open={endOpen}
                            onOpenChange={this.handleEndOpenChange}
                        />
                    </div>

                

                </div>
                {endDateMessage}
            </div>
            : null

        let dividor = this.state.addresses.length != 0 && this.state.contacts.length != 0 ? <hr /> : ''

        let shrinkedOrNot = !this.state.shrinked ?
            <div>
                {datePicker}

                <Tooltip placement="topLeft" title="Add phone number, website, email, address, Fax, social media links">
                    <h4 style={{ marginTop: '1em' }}><Icon type="info-circle" /> Contacts:</h4>
                </Tooltip>

                {this.state.addresses.map((add, i) => {

                    let text = add.street + ", " + add.zipCode.value + ", " + add.city.name + " (" + add.city.province.initials + ")"

                    if (this.state.beShowAddress) {

                        return (<div className="wizardHrContacts" key={i}>
                            <p style={{ marginBottom: '20px' }}>
                                <Checkbox
                                    disabled={false}
                                    onChange={() => this.setState({ showAddress: !this.state.showAddress, contactModified: true })}
                                    checked={this.state.showAddress}
                                >
                                    {text}
                                </Checkbox>
                            </p>
                        </div>)
                    }
                })
                }

                {dividor}

                {this.state.contacts.map((con, i) => {

                    if (con.isCollaboration) {
                        return (<div className="wizardHrContacts" key={i}>
                            <p style={{ marginBottom: '20px' }}>
                                <Checkbox
                                    disabled={false}
                                    onChange={() => {
                                        let contatti = this.state.contacts
                                        contatti[i].remove = !contatti[i].remove
                                        this.setState({ contacts: contatti, contactModified: true })
                                    }}
                                    checked={!this.state.contacts[i].remove}
                                >
                                    {con.text}
                                </Checkbox>
                            </p>
                        </div>)
                    } else {

                        return (
                            <div className="wizardHrContacts" id={"contactHr_" + this.state.roleId + "_" + this.state.hrId + "_" + i} key={i}>
                                <Input autoComplete="new-password" defaultValue={con.text} onPressEnter={() => this.addInput(i)} onBlur={() => this.addContact(i)} onChange={(e) => this.handleContactText(e, i)} className={"modified"} style={{ width: 'calc(100% - 34px)', height: '100%' }} addonBefore={selectBeforeProp(i)} placeholder="Insert text" />
                                <Popconfirm title="Are you sure delete this contact?" okText="Yes" cancelText="No" onConfirm={() => this.removeContact(i)} ><Icon style={{ marginLeft: '14px', marginTop: '1px', cursor: 'pointer', top: '2px', position: 'relative' }} className={"anticon-save deleteDisplay" + this.state.contacts.hasOwnProperty(i)} type="close" /></Popconfirm>
                                <p className="emailHasAt" style={{ display: 'none' }} id={"emailHasAtHr" + i + this.state.roleId + this.state.uniqueId}> Warning! "@" is missing</p>
                                <p className="emailHasAt" style={{ display: 'none' }} id={"urlHasHttp" + i + this.state.roleId + this.state.uniqueId}> Warning! http:// or https:// are missing</p>
                            </div>
                        )
                    }
                })
                }

                <Button onClick={() => this.addInput(this.state.contactHrId)} className="createContactButton" icon="plus"></Button>

                <div className="buttonsSaveHr">
                    {hrSave}
                    <Button onClick={this.shrink} className="deleteButtonHrWizard" icon="shrink">Collapse</Button>
                    <Popconfirm placement="top" title="Are you sure you want to delete HR from this role?" onConfirm={this.deleteHr} okText="Yes" cancelText="No"><Button className="deleteButtonHrWizard"><Icon type="close" /> Delete Hr</Button></Popconfirm>
                </div>
            </div> :

            <div className={"buttonsSaveHrShrinked" + this.state.disabledHrDetails}>
                {hrSave}
                <Button onClick={this.expand} className="deleteButtonHrWizard" icon="arrows-alt">Expand</Button>
                <Popconfirm placement="top" title="Are you sure you want to delete HR from this role?" onConfirm={this.deleteHr} okText="Yes" cancelText="No"><Button className="deleteButtonHrWizard"><Icon type="close" /> Delete Hr</Button></Popconfirm>
            </div>

        let goGreen = this.state.hrCreated || this.state.disabledHrDetails ? true : false
        let showHr = this.state.hrDeleted ? "" :
            <div style={{ width: '100%', listStyle: 'none' }} className="hrListBox">
                <div className={goGreen + "" + this.state.hrDeleted + "hrCreated" + checkGreen}>
                    {nameSurnameDetail}
                    {shrinkedOrNot}
                </div>

            </div>
        

        return (
            <div>
                {showHr}                
            </div>
        )
    }
}

export default EditHr;


// WEBPACK FOOTER //
// ./src/EditWizard/EditHr.js